import { Component, OnInit } from '@angular/core';
import { ReservationTenantService, CommonService } from '../../../services';
import { ReservationDto, Dictionary } from '../../../models';
import { MessageService } from 'primeng/api';
import { ReservationTenantsComponent } from '../reservation-tenants.component';
import * as globals from '../../../globals';

@Component({
  selector: 'app-reservation-tenants-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ReservationTenantsListComponent implements OnInit {
  reservations: ReservationDto[];
  carparks: Map<number, string>;
  companies: Map<number, string>;
  carparksOptions = [];
  companiesOptions = [];
  pl = globals.pl;

  constructor(
    private reservationService: ReservationTenantService,
    private commonsService: CommonService,
    public parent: ReservationTenantsComponent,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.carparks = new Map<number, string>();
    this.companies = new Map<number, string>();
    this.commonsService.getCarParks().subscribe(
      carparks => {
        carparks.forEach(carpark => {
          this.carparks.set(carpark.id, carpark.name);
          this.carparksOptions.push({ label: carpark.name, value: carpark.id });
        });
        this.commonsService.getCompanies().subscribe(
          companies => {
            companies.forEach(company => {
              this.companies.set(company.id, company.name);
              this.companiesOptions.push({ label: company.name, value: company.id });
            });

            this.refreshReservations();
          },
          error => {
            console.error(error);
          }
        );
      },
      error => {
        console.error(error);
      }
    );
  }

  cancelReservation(idReservation: number) {
    this.reservationService.cancelReservation(idReservation).subscribe(
      () => {
        this.messageService.add({ severity: 'success', summary: 'Anulowano rezerwację' });
        this.refreshReservations();
      },
      (error) => this.messageService.add({ severity: 'error', summary: 'Błąd anulowania rezerwacji', detail: error })
    );
  }

  refreshReservations() {
    this.reservationService.getReservations(this.parent.filter).subscribe(
      resList => {
        console.log(resList, this.carparks, this.companies);
        this.reservations = resList;
      },
      error => {
        console.error(error);
      }
    );
  }
}
